import { render, staticRenderFns } from "./ExtratoCliente.vue?vue&type=template&id=7a316ff9"
import script from "./ExtratoCliente.vue?vue&type=script&lang=js"
export * from "./ExtratoCliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports